import { render } from "./PokemonPage.vue?vue&type=template&id=38668641&scoped=true"
import script from "./PokemonPage.vue?vue&type=script&lang=js"
export * from "./PokemonPage.vue?vue&type=script&lang=js"

import "./PokemonPage.vue?vue&type=style&index=0&id=38668641&scoped=true&lang=css"

import exportComponent from "C:\\Users\\noahe\\OneDrive\\Documentos\\Udemy - Vue\\Vue\\04-pokemon-game\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38668641"]])

export default __exports__